import React from 'react';
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button';
import { Separator } from '@radix-ui/react-select';
import { useEffect } from 'react'

function About() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>

<div className="text-center max-w-prose mx-auto my-24 xl:my-36 px-8">
  <p className="text-3xl font-custom text-white">
    The community platform for knowledge sharing across museums.
  </p>
  <div className="flex flex-col md:flex-row justify-between my-8 space-y-2 md:space-y-0 md:space-x-2">
    <Button
      asChild
      className="w-full dark bg-[#f5f5f5] font-sans text-[#4d4dff] hover:text-[#4d4dff] hover:bg-white"
      variant="secondary"
    >
      <Link to="https://online.museumcircle.org" target="_self">Sign in</Link>
    </Button>

    <Button
      asChild
      className="w-full dark bg-transparent border-2 border-white font-sans text-white hover:bg-white hover:text-[#4d4dff] hover:border-white"
      variant="outline"
    >
      <Link to="/requestaccess">Become a member →</Link>
    </Button>
  </div>
</div>


      <div className='text-center mx-auto my-36 md:my-48 container px-8'>
        <p className="text-3xl font-custom text-white">
          Get started with..
        </p>
        {/* blocks */}
        {/* <div className='flex my-8 items-start justify-center gap-2 text-start'>
          <div className='bg-white rounded-3xl p-16 flex-1 text-[#4d4dff] hover:bg-[#6666ff] hover:text-white'>
            <p className="text-3xl font-custom  mb-2">
              Digital transformation
            </p>
            <p className="text-sm font-sans">
              ace for museum professionals and their shared goals. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
            </p>
          </div>

          <div className='bg-white rounded-3xl p-16 flex-1 text-[#4d4dff] hover:bg-[#6666ff] hover:text-white'>
            <p className="text-3xl font-custom  mb-2">
              Visitor participation
            </p>
            <p className="text-sm font-sans ">
              ace for museum professionals and their shared goals. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
            </p>
          </div>

          <div className='bg-white rounded-3xl p-16 flex-1 text-[#4d4dff] hover:bg-[#6666ff] hover:text-white'>
            <p className="text-3xl font-custom  mb-2">
              Reaching young audiences
            </p>
            <p className="text-sm font-sans ">
              ace for museum professionals and their shared goals. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
            </p>
          </div>

          <div className='bg-white rounded-3xl p-16 flex-1 text-[#4d4dff] hover:bg-[#6666ff] hover:text-white'>
            <p className="text-3xl font-custom  mb-2">
              Collaborative practices
            </p>
            <p className="text-sm font-sans ">
              ace for museum professionals and their shared goals. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
            </p>
          </div>
        </div> */}

<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2 my-8 text-start">
  <div className="bg-white rounded-3xl p-16 text-[#4d4dff] hover:bg-[#6666ff] hover:text-white">
    <p className="text-3xl font-custom mb-2">Digital transformation</p>
    <p className="text-sm font-sans">
    This community explores the latest digital innovations suitable for museum professionals. Whether dealing with online collections, interactive experiences, 3D scanning, or the use of augmented reality and AI, this space will inspire new solutions for your workflow and future audience.
    </p>
  </div>

  <div className="bg-white rounded-3xl p-16 text-[#4d4dff] hover:bg-[#6666ff] hover:text-white">
    <p className="text-3xl font-custom mb-2">Visitor participation</p>
    <p className="text-sm font-sans">
    In this community, we explore ways to foster a more active relationship between museums and their visitors. Whether through co-creation, interactive educational programs, or visitor-led initiatives, this space will highlight new approaches and research in the field of participation.
    </p>
  </div>

  <div className="bg-white rounded-3xl p-16 text-[#4d4dff] hover:bg-[#6666ff] hover:text-white">
    <p className="text-3xl font-custom mb-2">Reaching young audiences</p>
    <p className="text-sm font-sans">
    By recognizing the needs and interests of younger generations, we explore practical solutions to make the museum more engaging and relevant for them. This space highlights tools and best practices in the field of outreach, program and education – both online and in real life.
    </p>
  </div>

  <div className="bg-white rounded-3xl p-16 text-[#4d4dff] hover:bg-[#6666ff] hover:text-white">
    <p className="text-3xl font-custom mb-2">Collaborative practices</p>
    <p className="text-sm font-sans">
    The platform approaches collaboration from multiple angles. As a community we encourage user-generated content, open dialogue, members-led courses and events, beta testing and sharing updates. Members are also able to connect and collaborate on new initiatives.
    </p>
  </div>
</div>

      </div>

      <div
        className='text-center mx-auto my-24 md:my-36 max-w-6xl px-8'> {/* Add mx-auto to center the div */}
        {/* <h1 className="text-2xl font-bold mb-6 font-custom">Home of data couture</h1> */}
        <p className="text-3xl font-custom text-white mb-8 max-w-prose mx-auto px-12 md:px-0">
          Get unlimited access to..
        </p>



        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-x-2 gap-y-2">
          <div className="hover:bg-[#6666ff] p-4 rounded-3xl flex justify-center items-center">
            {/* Icon 1 */}
            <div
            className='m-12'>
              <p className="text-5xl font-sans text-white mb-2">
              ●
              </p>
              <p className="text-lg font-sans text-white">
                Online & local museum events
              </p>
            </div>
          </div>
          <div className="hover:bg-[#6666ff] p-4 rounded-3xl flex justify-center items-center">
            {/* Icon 2 */}
            <div className='m-12'>
              <p className="text-5xl font-sans text-white mb-2">
              ▲
              </p>
              <p className="text-lg font-sans text-white">
                Updates on latest news
              </p>
            </div>
          </div >
          <div className="hover:bg-[#6666ff] p-4 rounded-3xl flex justify-center items-center">
            {/* Icon 3 */}
            <div className='m-12'>
              <p className="text-5xl font-sans text-white mb-2">
              ■
              </p>
              <p className="text-lg font-sans text-white">
                Resource hub
              </p>
            </div>
          </div>
          <div className="hover:bg-[#6666ff] p-4 rounded-3xl flex justify-center items-center">
            {/* Icon 4 */}
            <div className='m-12'>
              <p className="text-5xl font-sans text-white mb-2">
              ◊
              </p>
              <p className="text-lg font-sans text-white">
                Connect with others
              </p>
            </div>
          </div>
          <div className="hover:bg-[#6666ff] p-4 rounded-3xl flex justify-center items-center">
            {/* Icon 5 */}
            <div className='m-12'>
              <p className="text-5xl font-sans text-white mb-2">
              ∑
              </p>
              <p className="text-lg font-sans text-white">
                Community spaces
              </p>
            </div>
          </div>
          <div className="hover:bg-[#6666ff] p-4 rounded-3xl flex justify-center items-center">
            {/* Icon 6 */}
            <div className='m-12'>
              <p className="text-5xl font-sans text-white mb-2">
              ○
              </p>
              <p className="text-lg font-sans text-white">
                Knowledge-sharing
              </p>
            </div>
          </div>
          <div className="hover:bg-[#6666ff] p-4 rounded-3xl flex justify-center items-center">
            {/* Icon 7 */}
            <div className='m-12'>
              <p className="text-5xl font-sans text-white mb-2">
              ↑
              </p>
              <p className="text-lg font-sans text-white">
                Live sessions
              </p>
            </div>
          </div>
          <div className="hover:bg-[#6666ff] p-4 rounded-3xl flex justify-center items-center">
            {/* Icon 8 */}
            <div className='m-12'>
              <p className="text-5xl font-sans text-white mb-2">
              ©
              </p>
              <p className="text-lg font-sans text-white">
                Advice from experts
              </p>
            </div>
          </div>
        </div>


      </div>

            {/* Bottom text */}

            <div
        className='text-center items-center max-w-prose mb-24 xl:mb-48 mx-auto px-8 '> {/* Add mx-auto to center the div */}
        {/* <h1 className="text-2xl font-bold mb-6 font-custom">Home of data couture</h1> */}
        <p className="text-3xl font-custom font-regular text-white">
          Museum Circle is an initiative by{' '}
          <a
            href="https://cypherstudio.org"
            target="_blank"
            rel="noopener noreferrer"
            className="font-custom_bold hover:underline text-white"
          >
            Cypher Studio
          </a>
          , and aligns with our mission to create accessible tools for the future of museums.
        </p>
        
        <Button
        asChild
        className="my-8 w-full dark bg-transparent border-2 border-white font-sans text-white hover:bg-white hover:text-[#4d4dff] hover:border-white"
        variant="outline">
          <Link to="/requestaccess">
          Become a member →</Link></Button>
      </div>

    </>
  );
}

export default About;